import axios from 'axios'

if (window.localStorage.getItem('token')) {
  axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token')
}

// window.axios.defaults.baseURL = 'https://mncgroup.info/be-controle-scn/public'
axios.defaults.baseURL = 'https://mncgroup.info/be-controle-scn/public'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// axios.interceptorsterceptors.request.use()
/*
axios.interceptors.response.use(response => {
  return response
}, function (err) {
  let title = 'Algo deu errado'
  let text = 'Uma situação inesperada ocorreu no servidor, por favor, entre em contato com o administrador'
  if (err.response && err.response.status === 401) {
    title = 'Autenticação!'
    text = 'Você precisa estar logado para acessar este recurso'
  }
  if (err.response && err.response.status === 422) {
    title = 'Verifique os dados'
    text = 'O servidor recusou os dados informado, confira as informações'
  }
  return Promise.reject({
    titulo: title,
    texto: text
  })
})
*/
window.axios = axios



// WEBPACK FOOTER //
// ./src/axios.js